import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import isEqual from "lodash.isequal";
import CellContainer from "../CellContainer.js";
import { getCellValueIsEmpty } from "../../../utils/cells.js";
import { named } from "../../../utils/named.js";
import { v4 } from "/app/node_modules/.pnpm/uuid@9.0.0/node_modules/uuid/dist/esm-browser/index.js";
import { createMessageMap } from "../EnumList/Renderer.js";
import "lodash.find";
import "react";
import "../../../common/UI/Loaders/Activity.js";
import "@flatfile/design-system";
import "react-i18next";
import "../Lookup/Styles.js";
import { Pills } from "../Lookup/Pills.js";
import "match-sorter";
import { ValueAddedPills, ValueRemoved, ValueRequiresDecisionPills } from "../Styles.js";
import { LabelContainer } from "./Styles.js";
const getFormattedValue = (value, status, isDiffView) => {
  if (getCellValueIsEmpty(value)) {
    return [];
  }
  const error = isDiffView ? [] : (status == null ? void 0 : status.error) ?? [];
  const warning = isDiffView ? [] : (status == null ? void 0 : status.warning) ?? [];
  const [errorMap, globalError] = createMessageMap({ value }, error);
  const [warningMap, globalWarning] = createMessageMap({ value }, warning);
  if (Array.isArray(value)) {
    if (value.every((v) => typeof v !== "string")) {
      return value.filter((v) => !getCellValueIsEmpty(v));
    }
    return value.map((v, i) => {
      const errorForIndex = globalError || errorMap.get(v);
      const warningForIndex = globalWarning || warningMap.get(v);
      return {
        value: v,
        label: v === null ? "null" : v.toString(),
        error: !!errorForIndex,
        warning: !!warningForIndex,
        key: v4()
      };
    });
  } else
    return [
      {
        value,
        label: value === null ? "null" : value.toString(),
        error: !!globalError,
        warning: !!globalWarning,
        key: v4()
      }
    ];
};
const Renderer = (props) => {
  var _a, _b;
  const { cell, isDiffView } = props;
  const diffValue = cell == null ? void 0 : cell.diffValue;
  const values = getFormattedValue(cell == null ? void 0 : cell.value, cell == null ? void 0 : cell.status, isDiffView);
  const formattedDiffValues = getFormattedValue(
    diffValue,
    cell == null ? void 0 : cell.status,
    isDiffView
  );
  const fullLabel = values.map((v) => v.label).join(", ");
  const showDiff = isDiffView && !isEqual(cell == null ? void 0 : cell.value, diffValue);
  const unresolvedDecision = ((_a = cell == null ? void 0 : cell.metadata) == null ? void 0 : _a.requiresDecision) && !(cell == null ? void 0 : cell.metadata.acceptedValue);
  const acceptedValue = (_b = cell == null ? void 0 : cell.metadata) == null ? void 0 : _b.acceptedValue;
  return /* @__PURE__ */ jsx(CellContainer, { ...props, innerStatus: !values.length ? props.status : {}, children: /* @__PURE__ */ jsx(LabelContainer, { title: fullLabel.length > 37 ? fullLabel : void 0, children: !showDiff ? /* @__PURE__ */ jsx(Pills, { options: values, allowRemove: false, ...props.status }) : (
    // Show diff view
    /* @__PURE__ */ jsxs(Fragment, { children: [
      values.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
        !unresolvedDecision && /* @__PURE__ */ jsx(Fragment, { children: acceptedValue === "source" ? /* @__PURE__ */ jsx(ValueAddedPills, { children: /* @__PURE__ */ jsx(Pills, { options: values, allowRemove: false }) }) : /* @__PURE__ */ jsx(ValueRemoved, { children: /* @__PURE__ */ jsx(Pills, { options: values, allowRemove: false }) }) }),
        unresolvedDecision && /* @__PURE__ */ jsx(ValueRequiresDecisionPills, { children: /* @__PURE__ */ jsx(Pills, { options: values, allowRemove: false }) })
      ] }),
      formattedDiffValues.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
        !unresolvedDecision && /* @__PURE__ */ jsx(Fragment, { children: acceptedValue === "source" ? /* @__PURE__ */ jsx(ValueRemoved, { children: /* @__PURE__ */ jsx(
          Pills,
          {
            options: formattedDiffValues,
            allowRemove: false
          }
        ) }) : /* @__PURE__ */ jsx(ValueAddedPills, { children: /* @__PURE__ */ jsx(
          Pills,
          {
            options: formattedDiffValues,
            allowRemove: false
          }
        ) }) }),
        unresolvedDecision && /* @__PURE__ */ jsx(ValueRequiresDecisionPills, { children: /* @__PURE__ */ jsx(Pills, { options: formattedDiffValues, allowRemove: false }) })
      ] })
    ] })
  ) }) });
};
named("MultiValueRenderer", Renderer);
export {
  Renderer as default,
  getFormattedValue
};
